export default __webpack_public_path__ + "static/media/SJA0450.34I-36953_-25734_0.f1a06666.jpg";